import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@emotion/react';
import { getStyleProps } from '../utils';
import { CrossIcon } from './indicators';
export const multiValueCSS = ({
  theme: {
    spacing,
    borderRadius,
    colors
  }
}, unstyled) => ({
  label: 'multiValue',
  display: 'flex',
  minWidth: 0,
  // resolves flex/text-overflow bug
  ...(unstyled ? {} : {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    margin: spacing.baseUnit / 2
  })
});
export const multiValueLabelCSS = ({
  theme: {
    borderRadius,
    colors
  },
  cropWithEllipsis
}, unstyled) => ({
  overflow: 'hidden',
  textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
  whiteSpace: 'nowrap',
  ...(unstyled ? {} : {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    padding: 3,
    paddingLeft: 6
  })
});
export const multiValueRemoveCSS = ({
  theme: {
    spacing,
    borderRadius,
    colors
  },
  isFocused
}, unstyled) => ({
  alignItems: 'center',
  display: 'flex',
  ...(unstyled ? {} : {
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  })
});
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const MultiValueGeneric = ({
  children,
  innerProps
}) => jsx("div", innerProps, children);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const MultiValueContainer = MultiValueGeneric;

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const MultiValueLabel = MultiValueGeneric;
export function MultiValueRemove({
  children,
  innerProps
}) {
  return jsx("div", _extends({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
const MultiValue = props => {
  const {
    children,
    components,
    data,
    innerProps,
    isDisabled,
    removeProps,
    selectProps
  } = props;
  const {
    Container,
    Label,
    Remove
  } = components;
  return jsx(Container, {
    data: data,
    innerProps: {
      ...getStyleProps(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
      }),
      ...innerProps
    },
    selectProps: selectProps
  }, jsx(Label, {
    data: data,
    innerProps: {
      ...getStyleProps(props, 'multiValueLabel', {
        'multi-value__label': true
      })
    },
    selectProps: selectProps
  }, children), jsx(Remove, {
    data: data,
    innerProps: {
      ...getStyleProps(props, 'multiValueRemove', {
        'multi-value__remove': true
      }),
      'aria-label': `Remove ${children || 'option'}`,
      ...removeProps
    },
    selectProps: selectProps
  }));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default MultiValue;